import * as Debug from 'debug';
import {AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../shared/services/user_service';
import {StreamService} from '../../shared/services/stream_service';
import {DomSanitizer, Title} from '@angular/platform-browser';
// import {MapsAPILoader} from '@agm/core';
import {Util} from '../../shared/util/util';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NoteService} from '../../shared/services/note_service';
import {ReportCommentModalComponent} from '../../shared/note-detailed/report-comment-modal/report-comment-modal.component';

import {User} from '../../shared/types/user';
import {Comment} from '../../shared/types/comment';
import {NoteRating} from '../../shared/types/note_rating';

import { Note } from '../../shared/types/note';
import { Stream } from '../../shared/types/stream';

const debug = Debug('notd:public-profile');

@Component({
  selector: 'notd-public-profile',
  templateUrl: './public-profile.component.html',
  styleUrls: ['./public-profile.component.scss']
})
export class PublicProfileComponent implements OnInit, AfterViewInit {
  @ViewChild('shareImgContent', {static: false}) public shareImgContent: ElementRef;

  public userNotes: Note[];
  public userStreams: Stream[];
  public userComments = [];
  public userRatings = [];

  public userProfile: User;
  public categories = ['Notes', 'Streams', 'Comments', 'Ratings'];
  public selectedCategory = this.categories[0];
  public loadingContent = true;
  public loadingMoreNotes = false;
  public notePageOffset = 10;
  public viewMode: string | null;
  public shareImgContentElement: ElementRef;
  private userIdent: string | number | null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private streamService: StreamService,
    private noteService: NoteService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private utilities: Util,
    private titleService: Title,
    private renderer: Renderer2,
    private modalService: NgbModal,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) protected platformId: Object) { }

  public ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.viewMode = this.route.snapshot.data.mode ? this.route.snapshot.data.mode : '';
      this.userIdent = params.userIdent;
      this.getUserProfile();
    });
    console.log(this);
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.shareImgContentElement = this.shareImgContent;
    });
  }

  public selectCategory(category: string): void {
    this.selectedCategory = category.toLowerCase();
    this.loadingContent = true;

    switch (this.selectedCategory) {
      case 'notes':
        this.getUserNotes();
        break;
      case 'streams':
        this.getUserStreams();
        break;
      case 'comments':
        this.getUserComments();
        break;
      case 'ratings':
        this.getUserRatings();
        break;
    }
  }

  public showMoreNotes(ev: Event): void {
    this.loadingMoreNotes = true;
    this.notePageOffset = this.notePageOffset + 10;

    setTimeout(() => {
      this.loadingMoreNotes = false;
    }, 300);
  }

  public readMore(streamId: string, streamName: string) {
    this.router.navigate(['/streams', streamId, 'view', streamName]);
  }

  public noteDeletedEvent(ev: any): void {
    this.selectCategory(this.categories[0]);
  }

  // public applyClassStylesAsInline(className: string, elementRef: ElementRef) {
  //   const tempElement = this.renderer.createElement('div');
  //   this.renderer.addClass(tempElement, className);
  //   this.renderer.appendChild(document.body, tempElement);

  //   const computedStyles = getComputedStyle(tempElement);

  //   for (const style of computedStyles) {
  //     this.renderer.setStyle(elementRef.nativeElement, style, computedStyles.getPropertyValue(style));
  //   }

  //   this.renderer.removeChild(document.body, tempElement);
  // }

  private getUserProfile(): void {
    this.userService.getUserProfile(this.userIdent).then((user: User) => {
      if (user.displayName) {
        this.titleService.setTitle(`${user.displayName} - notd.io`);
      }

      this.userProfile = user;
      this.selectCategory(this.viewMode || this.categories[0]);
    }, err => {
      console.error('There was and issue while fetching user profile', err);
    });
  }

  private getUserNotes(): void {
    this.userService
      .getUserNotes(this.userIdent)
      .then((notes: any) => {
        this.userNotes = notes && notes.posts ? notes.posts : [];
        this.loadingContent = false;
      }, err => {
        this.userNotes = [];
        this.loadingContent = false;
      });
  }

  private getUserStreams(): void {
    this.streamService.getStreamsByUserId(this.userIdent).then(streamList => {
      this.userStreams = streamList;
      this.loadingContent = false;
    });
  }

  private getUserComments(): void {
    this.userService.getUserCommentsList(typeof this.userIdent === 'string' ? this.userProfile.id : this.userIdent)
      .then((commentList: Comment[] | any) => {
      this.loadingContent = false;

      for (const c of commentList) {
        this.noteService.getNoteInfo(c.postId).then((note: Note) => {
          this.userComments.push({
            noteId: c.postId,
            noteTitle: note.name,
            noteThumb: note.thumbnailImage || false,
            comment: c.comments,
            likes: c.likes,
            dislikes: c.dislikes,
            created: c.created,
          });
        });
      }
    }, err => {
      console.error('Error while geting note details', err);
    });
  }

  private getUserRatings(): void {
    this.userService.getUserRatingsList(typeof this.userIdent === 'string' ? this.userProfile.id : this.userIdent)
      .then((ratingsList: NoteRating[]) => {
      this.loadingContent = false;

      ratingsList.map((r: NoteRating) => {
        this.noteService.getNoteInfo(r.postId).then((note: Note) => {
          this.userRatings.push({
            noteId: r.postId,
            noteTitle: note.name,
            noteThumb: note.thumbnailImage || false,
            rating: r.rating,
            created: r.created
          });
        }, () => {
          console.log(`This note doesnt exist anymore ${r.postId}`);
        });
      });
    });
  }
}
